<template>
	<div
		class="o-checkbox o-checkbox__wrapper"
		:class="{ 'o-checkbox--invalid': invalidStyle }"
	>
		<input
			:id="id"
			:name="id"
			:required="required"
			:ref="ref"
			:checked="modelValue"
			type="checkbox"
			@change="checkboxChange($event)"
			@blur="fieldChanged()"
		/>
		<label class="o-checkbox" :for="id">
			<span class="field">
				<svg
					width="10"
					height="8"
					viewBox="0 0 10 8"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M1 4.2L3.4 6.6L9 1" stroke="white" />
				</svg>
			</span>
			<span class="label">
				<slot></slot>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'FieldCheckbox',
	props: {
		id: String,
		modelValue: {
			type: Boolean,
			default: false,
		},
		doValidate: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		ref: {
			type: String,
		},
		isChecked: {
			type: Boolean,
		},
	},
	data: () => {
		return {
			invalidStyle: false,
			isValid: false,
		};
	},
	watch: {
		doValidate() {
			this.fieldChanged();
		},
		modelValue() {
			this.fieldChanged();
		},
	},
	methods: {
		checkboxChange(event) {
			this.$emit('update:modelValue', event.target.checked);
		},

		fieldChanged() {
			// VALIDATE
			if (this.required) {
				if (this.modelValue) {
					this.isValid = true;

					if (this.doValidate) {
						this.invalidStyle = false;
					}
				} else {
					this.isValid = false;

					if (this.doValidate) {
						this.invalidStyle = true;
					}
				}

				this.$emit('updateValid', {
					fieldname: this.id,
					isfieldvalid: this.isValid,
				});
			}
		},
	},

	mounted() {
		this.fieldChanged();

		if (this.isChecked) {
			this.$emit('update:modelValue', true);
		}
	},
};
</script>
